import { render, staticRenderFns } from "./ClaimTicket.vue?vue&type=template&id=5a9b2598&"
import script from "./ClaimTicket.vue?vue&type=script&lang=js&"
export * from "./ClaimTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports